//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface AccountExportModel {
  id?: number;
  name?: string | undefined;
  email?: string | undefined;
  jobTitle?: string | undefined;
  team?: string | undefined;
  workPhoneNumber?: string | undefined;
  workPhoneExtension?: string | undefined;
  mobilePhoneNumber?: string | undefined;
  timeZone?: string | undefined;
  hasSignature?: boolean;
  isActive?: boolean;
  lastLoginDate?: string | undefined;
  lastActivatedDate?: string | undefined;
  lastDeactivatedDate?: string | undefined;
  securityRole?: string | undefined;
  /** 

1 = Global

2 = Selected

3 = Participant */
  subtypeAccess?: SubtypeAccessLevel;
  /** 

1 = User

2 = ServiceAccount */
  accountType?: AccountType;
}

export interface AccountExportModelPagedResponseModel {
  totalCount?: number;
  items?: AccountExportModel[] | undefined;
}

export interface AccountLoginModel {
  id?: number;
  name?: string | undefined;
  email?: string | undefined;
  /** 

1 = User

2 = ServiceAccount */
  accountType?: AccountType;
  loginDate?: string;
}

export interface AccountLoginModelPagedResponseModel {
  totalCount?: number;
  items?: AccountLoginModel[] | undefined;
}

/** 1 = User 2 = ServiceAccount */
export enum AccountType {
  User = 1,
  ServiceAccount = 2
}

export interface AddressModel {
  street1?: string | undefined;
  street2?: string | undefined;
  city?: string | undefined;
  /** 

1 = Alabama

2 = Alaska

3 = Arizona

4 = Arkansas

5 = California

6 = Colorado

7 = Connecticut

8 = Delaware

9 = Florida

10 = Georgia

11 = Hawaii

12 = Idaho

13 = Illinois

14 = Indiana

15 = Iowa

16 = Kansas

17 = Kentucky

18 = Louisiana

19 = Maine

20 = Maryland

21 = Massachusetts

22 = Michigan

23 = Minnesota

24 = Mississippi

25 = Missouri

26 = Montana

27 = Nebraska

28 = Nevada

29 = NewHampshire

30 = NewJersey

31 = NewMexico

32 = NewYork

33 = NorthCarolina

34 = NorthDakota

35 = Ohio

36 = Oklahoma

37 = Oregon

38 = Pennsylvania

39 = RhodeIsland

40 = SouthCarolina

41 = SouthDakota

42 = Tennessee

43 = Texas

44 = Utah

45 = Vermont

46 = Virginia

47 = Washington

48 = WestVirginia

49 = Wisconsin

50 = Wyoming

51 = DistrictOfColumbia

52 = Alberta

53 = BritishColumbia

54 = Manitoba

55 = NewBrunswick

56 = Newfoundland

57 = NorthwestTerritories

58 = NovaScotia

59 = Nunavut

60 = Ontario

61 = PrinceEdwardIsland

62 = Quebec

63 = Saskatchewan

64 = Yukon

70 = UsTerritories

71 = Other */
  state?: State | undefined;
  /** 

1 = UnitedStates

2 = Canada */
  country?: Country | undefined;
  zipCode?: string | undefined;
}

export interface ApiError {
  error?: ErrorDetail | undefined;
}

/** 2 = Rms 3 = Lpms */
export enum App {
  Rms = 2,
  Lpms = 3
}

export interface ApplicationModel {
  /** 

2 = Rms

3 = Lpms */
  app?: App;
  dateEnabled?: string;
}

export interface AuthUserModel {
  id?: number;
  companyId?: number;
}

export interface CompanyCommunicationOverrideModel {
  disableAllCommunication?: boolean;
  email?: string | undefined;
  fax?: string | undefined;
}

export interface CompanyModel {
  id?: number;
  name?: string | undefined;
  fullName?: string | undefined;
  domainName?: string | undefined;
  intakeEmailDomain?: string | undefined;
  maxFileSizeInMB?: number;
  applications?: ApplicationModel[] | undefined;
  coordinators?: CoordinatorModel[] | undefined;
  safariNumberPad?: number;
  hasSsoEnabled?: boolean;
  /** 

1 = DefaultOn

2 = DefaultOff

3 = AlwaysOn */
  requireOneTimePinDefault?: RequireOneTimePinDefault;
  enableRetentionPolicies?: boolean;
  /** 

1 = Team

2 = CompanyEntity */
  supportContactLevel?: SupportContactLevel;
  enableCompanyEditablePicklists?: boolean;
  useServePort?: boolean;
  enableDataExfiltrationProtection?: boolean;
  enableScim?: boolean;
  enabledSubjectSearchMatterTypes?: MatterType[] | undefined;
  enabledAccountLookupMatterTypes?: MatterType[] | undefined;
  /** 

1 = Standard

2 = Ledger_Automated

3 = Ledger_Manual */
  garnishmentProcessing?: GarnishmentProcessingType;
  enableDeliveryPortalAcknowledgment?: boolean;
  enableNotifiedTeamsTracking?: boolean;
  enableGarnishmentAutoResponse?: boolean;
  enableDocExtractor?: boolean;
}

export interface CompanyModelPagedResponseModel {
  totalCount?: number;
  items?: CompanyModel[] | undefined;
}

export interface CompanyRegisteredAgentModel {
  id?: number;
  name?: string | undefined;
  cscSettings?: CscSettingsModel | undefined;
  ctSettings?: CtSettingsModel | undefined;
  gemsSettings?: GemsSettingsModel | undefined;
}

export interface CompanyRegisteredAgentModelPagedResponseModel {
  totalCount?: number;
  items?: CompanyRegisteredAgentModel[] | undefined;
}

export interface CompanyRegisteredAgentSettingsModel {
  cscSettings?: CscSettingsModel | undefined;
  ctSettings?: CtSettingsModel | undefined;
  gemsSettings?: GemsSettingsModel | undefined;
}

export interface CoordinatorModel {
  userId?: number;
  companyId?: number;
  isLead?: boolean;
  fullName?: string | undefined;
  isActive?: boolean;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  phoneNumbers?: PhoneNumberModel[] | undefined;
}

export interface CoordinatorModelPagedResponseModel {
  totalCount?: number;
  items?: CoordinatorModel[] | undefined;
}

/** 1 = UnitedStates 2 = Canada */
export enum Country {
  UnitedStates = 1,
  Canada = 2
}

export interface CreateCompanyModel {
  name: string;
  fullName: string;
  domainName: string;
  authenticationConnectionName?: string | undefined;
}

export interface CreateRegisteredAgentImportModel {
  /** 

1 = Csc

2 = Ct

3 = Gems */
  agent?: RegisteredAgent | undefined;
  date?: string | undefined;
  /** 

1 = InProgress

2 = Completed

3 = Failed */
  status?: RegisteredAgentImportStatus | undefined;
}

export interface CreateTeamModel {
  name: string;
  address?: AddressModel | undefined;
  reviewerIsSupportContact?: boolean;
  deliveryPortalContactName?: string | undefined;
  deliveryPortalContactEmail?: string | undefined;
  invoiceContactName?: string | undefined;
  invoiceContactEmail?: string | undefined;
}

export interface CreateUserModel {
  firstName: string;
  lastName: string;
  email: string;
  isActive?: boolean;
  teamId?: number | undefined;
  jobTitle?: string | undefined;
  timeZone?: string | undefined;
  phoneNumbers?: PhoneNumberModel[] | undefined;
  roles?: number[] | undefined;
  securityRoles?: SecurityRole[] | undefined;
  /** Indicates the user has access to all matter subtypes */
  hasAccessToAllMatterSubtypes?: boolean;
  /** The matter types that this user can access without being a participant */
  matterTypes?: MatterType[] | undefined;
  /** The matter subtypes that this user can access without being a participant */
  matterSubtypeIds?: number[] | undefined;
  disableWelcomeEmail?: boolean;
}

export interface CscSettingsModel {
  isEnabled?: boolean;
  goLiveDate?: string | undefined;
  username?: string | undefined;
  password?: string | undefined;
  feedId?: string | undefined;
  apiKey?: string | undefined;
  /** The request type to use for all SOP documents that didn't match a type in SafariLaw.CoManage.Api.Models.Company.CscSettingsModel.RegisteredAgentTypeMaps.  
Leave this null to skip importing types not needed in Safari. */
  matterSubtypeId_CatchAll?: number | undefined;
  registeredAgentTypeMaps?: RegisteredAgentTypeMapModel[] | undefined;
}

export interface CtSettingsModel {
  isEnabled?: boolean;
  goLiveDate?: string | undefined;
  username?: string | undefined;
  password?: string | undefined;
  channelId?: string | undefined;
  /** The request type to use for all SOP documents that didn't match a type in SafariLaw.CoManage.Api.Models.Company.CtSettingsModel.RegisteredAgentTypeMaps.  
Leave this null to skip importing types not needed in Safari. */
  matterSubtypeId_CatchAll?: number | undefined;
  registeredAgentTypeMaps?: RegisteredAgentTypeMapModel[] | undefined;
}

export interface DeveloperException {
  readonly message?: string | undefined;
  source?: string | undefined;
  readonly stackTrace?: string | undefined;
  readonly innerException?: DeveloperException | undefined;
}

export interface DownloadAccountLoginExportQueryModel {
  startDate?: string | undefined;
  endDate?: string | undefined;
  /** An optional filter to a single ID of a User or Service account */
  accountId?: number | undefined;
  /** Duration the link remains active. Default is 5 minutes. */
  durationInMinutes?: number;
  /** If true, the link's content-disposition header will be set to `inline` otherwise `attachment` */
  openInBrowser?: boolean;
}

export interface DownloadLinkModel {
  name?: string | undefined;
  contentType?: string | undefined;
  sizeInBytes?: number | undefined;
  linkUrl?: string | undefined;
  dateLinkExpires?: string;
}

export interface DownloadUserExportQueryModel {
  activeOnly?: boolean | undefined;
  /** Duration the link remains active. Default is 5 minutes. */
  durationInMinutes?: number;
  /** If true, the link's content-disposition header will be set to `inline` otherwise `attachment` */
  openInBrowser?: boolean;
}

/** 1 = Small 2 = Medium 3 = Large */
export enum EmployeeSize {
  Small = 1,
  Medium = 2,
  Large = 3
}

/** 0 = Unknown 1 = BadInput 2 = ConcurrencyError 3 = NoRecordFound 4 = PaymentRequired 5 = Forbidden 6 = TooManyRequests 7 = RetryAfter 8 = ClientDisconnect 9 = NotAuthorized */
export enum ErrorCode {
  Unknown = 0,
  BadInput = 1,
  ConcurrencyError = 2,
  NoRecordFound = 3,
  PaymentRequired = 4,
  Forbidden = 5,
  TooManyRequests = 6,
  RetryAfter = 7,
  ClientDisconnect = 8,
  NotAuthorized = 9
}

export interface ErrorDetail {
  /** 

0 = Unknown

1 = BadInput

2 = ConcurrencyError

3 = NoRecordFound

4 = PaymentRequired

5 = Forbidden

6 = TooManyRequests

7 = RetryAfter

8 = ClientDisconnect

9 = NotAuthorized */
  code?: ErrorCode;
  message?: string | undefined;
  details?: ErrorDetail[] | undefined;
  target?: string | undefined;
  developerException?: DeveloperException | undefined;
}

/** 1 = Standard 2 = Ledger_Automated 3 = Ledger_Manual */
export enum GarnishmentProcessingType {
  Standard = 1,
  Ledger_Automated = 2,
  Ledger_Manual = 3
}

export interface GemsSettingsModel {
  isEnabled?: boolean;
  goLiveDate?: string | undefined;
  companyIdentifier?: string | undefined;
  clientId?: string | undefined;
  clientSecret?: string | undefined;
  searchId?: string | undefined;
  /** The request type to use for all SOP documents that didn't match a type in SafariLaw.CoManage.Api.Models.Company.GemsSettingsModel.RegisteredAgentTypeMaps.  
Leave this null to skip importing types not needed in Safari. */
  matterSubtypeId_CatchAll?: number | undefined;
  registeredAgentTypeMaps?: RegisteredAgentTypeMapModel[] | undefined;
}

export interface IdResultModel {
  id?: number;
}

export interface InboundEmailSettingsModel {
  emailName?: string | undefined;
  validDomains?: string[] | undefined;
  matterSubtypeId?: number;
  requireAttachments?: boolean;
}

export interface InboundEmailSettingsModelPagedResponseModel {
  totalCount?: number;
  items?: InboundEmailSettingsModel[] | undefined;
}

/** 1 = AutomobilesAndComponents 2 = Banks 3 = CapitalGoods 4 = CommercialAndProfessionalServices 5 = ConsumerDurablesAndApparel 6 = ConsumerServices 7 = CreditUnions 8 = Energy 9 = FoodBeverageTobacco 10 = FoodAndStaplesRetailing 11 = HealthCareEquipmentAndServices 12 = HouseholdAndPersonalProducts 13 = Insurance 14 = Materials 15 = MediaAndEntertainment 16 = PharmaceuticalsBiotechnologyLifeSciences 17 = RealEstate 18 = Retailing 19 = Semiconductors 20 = SoftwareAndServices 21 = TechnologyHardwareEquipment 22 = TelecommunicationServices 23 = Transportation 24 = Utilities */
export enum IndustryClassification {
  AutomobilesAndComponents = 1,
  Banks = 2,
  CapitalGoods = 3,
  CommercialAndProfessionalServices = 4,
  ConsumerDurablesAndApparel = 5,
  ConsumerServices = 6,
  CreditUnions = 7,
  Energy = 8,
  FoodBeverageTobacco = 9,
  FoodAndStaplesRetailing = 10,
  HealthCareEquipmentAndServices = 11,
  HouseholdAndPersonalProducts = 12,
  Insurance = 13,
  Materials = 14,
  MediaAndEntertainment = 15,
  PharmaceuticalsBiotechnologyLifeSciences = 16,
  RealEstate = 17,
  Retailing = 18,
  Semiconductors = 19,
  SoftwareAndServices = 20,
  TechnologyHardwareEquipment = 21,
  TelecommunicationServices = 22,
  Transportation = 23,
  Utilities = 24
}

export interface IntakeFaxSettingsModel {
  name?: string | undefined;
  matterSubtypeId?: number;
  faxId?: string | undefined;
  faxNumber?: string | undefined;
}

export interface IntakeFaxSettingsModelPagedResponseModel {
  totalCount?: number;
  items?: IntakeFaxSettingsModel[] | undefined;
}

/** 1 = DocumentRequest 2 = Garnishment 3 = Litigation 4 = Other */
export enum MatterType {
  DocumentRequest = 1,
  Garnishment = 2,
  Litigation = 3,
  Other = 4
}

export interface OperationModel {
  id?: string;
  lastUpdatedDateTime?: string;
  name?: string | undefined;
  /** 

0 = Pending

1 = Success

2 = Failure */
  status?: OperationStatus;

  [key: string]: any;
}

/** 0 = Pending 1 = Success 2 = Failure */
export enum OperationStatus {
  Pending = 0,
  Success = 1,
  Failure = 2
}

export interface PhoneNumberModel {
  number?: string | undefined;
  extension?: string | undefined;
  /** 

1 = HomePhone

2 = WorkPhone

3 = CellPhone

4 = WorkFax */
  type?: PhoneType;
  isPrimary?: boolean;
}

/** 1 = HomePhone 2 = WorkPhone 3 = CellPhone 4 = WorkFax */
export enum PhoneType {
  HomePhone = 1,
  WorkPhone = 2,
  CellPhone = 3,
  WorkFax = 4
}

export interface PicklistResultModel {
  /** 

1 = Countries

2 = States

3 = PhoneTypes

4 = TimeZones

5 = UserPermissions

6 = Applications

7 = MatterSubtypes

8 = RequireOneTimePinDefaults

9 = EmployeeSizes

10 = IndustryClassifications

11 = RegisteredAgents

12 = RegisteredAgentImportStatuses

13 = WhiteLabelEmailTypes

14 = SupportContactLevels

15 = AccountTypes

16 = SubtypeAccessLevels

17 = GarnishmentProcessingTypes

18 = ServingPartyOrgTypes

19 = RegisteredAgencyRequestSources

20 = RegisteredAgencyResponseTypes */
  type?: PicklistType;
  values?: PicklistValueModel[] | undefined;
}

export interface PicklistResultModelPagedResponseModel {
  totalCount?: number;
  items?: PicklistResultModel[] | undefined;
}

/** 1 = Countries 2 = States 3 = PhoneTypes 4 = TimeZones 5 = UserPermissions 6 = Applications 7 = MatterSubtypes 8 = RequireOneTimePinDefaults 9 = EmployeeSizes 10 = IndustryClassifications 11 = RegisteredAgents 12 = RegisteredAgentImportStatuses 13 = WhiteLabelEmailTypes 14 = SupportContactLevels 15 = AccountTypes 16 = SubtypeAccessLevels 17 = GarnishmentProcessingTypes 18 = ServingPartyOrgTypes 19 = RegisteredAgencyRequestSources 20 = RegisteredAgencyResponseTypes */
export enum PicklistType {
  Countries = 1,
  States = 2,
  PhoneTypes = 3,
  TimeZones = 4,
  UserPermissions = 5,
  Applications = 6,
  MatterSubtypes = 7,
  RequireOneTimePinDefaults = 8,
  EmployeeSizes = 9,
  IndustryClassifications = 10,
  RegisteredAgents = 11,
  RegisteredAgentImportStatuses = 12,
  WhiteLabelEmailTypes = 13,
  SupportContactLevels = 14,
  AccountTypes = 15,
  SubtypeAccessLevels = 16,
  GarnishmentProcessingTypes = 17,
  ServingPartyOrgTypes = 18,
  RegisteredAgencyRequestSources = 19,
  RegisteredAgencyResponseTypes = 20
}

export interface PicklistValueModel {
  id?: string | undefined;
  name?: string | undefined;

  [key: string]: any;
}

export interface PicklistValueModelPagedResponseModel {
  totalCount?: number;
  items?: PicklistValueModel[] | undefined;
}

/** 1 = SafariHosted 2 = AgencyHosted */
export enum RegisteredAgencyRequestSource {
  SafariHosted = 1,
  AgencyHosted = 2
}

/** 1 = X9SafariHosted 2 = X9AgencyHosted 3 = Email */
export enum RegisteredAgencyResponseType {
  X9SafariHosted = 1,
  X9AgencyHosted = 2,
  Email = 3
}

/** 1 = Csc 2 = Ct 3 = Gems */
export enum RegisteredAgent {
  Csc = 1,
  Ct = 2,
  Gems = 3
}

export interface RegisteredAgentImportModel {
  id?: number;
  /** 

1 = Csc

2 = Ct

3 = Gems */
  agent?: RegisteredAgent | undefined;
  date?: string | undefined;
  /** 

1 = InProgress

2 = Completed

3 = Failed */
  status?: RegisteredAgentImportStatus | undefined;
}

export interface RegisteredAgentImportModelPagedResponseModel {
  totalCount?: number;
  items?: RegisteredAgentImportModel[] | undefined;
}

/** 1 = InProgress 2 = Completed 3 = Failed */
export enum RegisteredAgentImportStatus {
  InProgress = 1,
  Completed = 2,
  Failed = 3
}

export interface RegisteredAgentTypeMapModel {
  registeredAgentType?: string | undefined;
  matterSubtypeId?: number;
}

/** 1 = DefaultOn 2 = DefaultOff 3 = AlwaysOn */
export enum RequireOneTimePinDefault {
  DefaultOn = 1,
  DefaultOff = 2,
  AlwaysOn = 3
}

export interface SafariCompanySettingsModel {
  authenticationConnectionName?: string | undefined;
  safariNumberPad?: number;
  domainName?: string | undefined;
  /** 

1 = Username

2 = Domain */
  whiteLabelEmailType?: WhiteLabelEmailType | undefined;
  whiteLabelEmailDomain?: string | undefined;
  /** 

1 = DefaultOn

2 = DefaultOff

3 = AlwaysOn */
  requireOneTimePinDefault?: RequireOneTimePinDefault | undefined;
  enableRetentionPolicies?: boolean;
  /** 

1 = Small

2 = Medium

3 = Large */
  employeeSize?: EmployeeSize | undefined;
  /** 

1 = AutomobilesAndComponents

2 = Banks

3 = CapitalGoods

4 = CommercialAndProfessionalServices

5 = ConsumerDurablesAndApparel

6 = ConsumerServices

7 = CreditUnions

8 = Energy

9 = FoodBeverageTobacco

10 = FoodAndStaplesRetailing

11 = HealthCareEquipmentAndServices

12 = HouseholdAndPersonalProducts

13 = Insurance

14 = Materials

15 = MediaAndEntertainment

16 = PharmaceuticalsBiotechnologyLifeSciences

17 = RealEstate

18 = Retailing

19 = Semiconductors

20 = SoftwareAndServices

21 = TechnologyHardwareEquipment

22 = TelecommunicationServices

23 = Transportation

24 = Utilities */
  industryClassification?: IndustryClassification | undefined;
  enableCompanyEditablePicklists?: boolean;
  useServePort?: boolean;
  enableDataExfiltrationProtection?: boolean;
  enableScim?: boolean;
  scimSettings?: ScimSettingsModel | undefined;
  enabledSubjectSearchMatterTypes?: MatterType[] | undefined;
  enabledAccountLookupMatterTypes?: MatterType[] | undefined;
  /** 

1 = Standard

2 = Ledger_Automated

3 = Ledger_Manual */
  garnishmentProcessing?: GarnishmentProcessingType;
  enableDeliveryPortalAcknowledgment?: boolean;
  enableNotifiedTeamsTracking?: boolean;
  enableGarnishmentAutoResponse?: boolean;
  enableDocExtractor?: boolean;
}

export interface ScimSettingsModel {
  enabled?: boolean;
  sendNewUserWelcomeEmail?: boolean;
}

/** 1 = Admin 2 = Creator 3 = Editor 4 = Viewer 5 = Uploader 6 = Owner */
export enum SecurityRole {
  Admin = 1,
  Creator = 2,
  Editor = 3,
  Viewer = 4,
  Uploader = 5,
  Owner = 6
}

export interface ServiceAccountListModel {
  id?: number;
  name?: string | undefined;
  isActive?: boolean;
  lastLoginDate?: string | undefined;
}

export interface ServiceAccountListModelPagedResponseModel {
  totalCount?: number;
  items?: ServiceAccountListModel[] | undefined;
}

export interface ServiceAccountModel {
  id?: number;
  name?: string | undefined;
  isActive?: boolean;
  primaryKey?: string | undefined;
  secondaryKey?: string | undefined;
  lastLoginDate?: string | undefined;
}

/** 1 = LawFirm 2 = StateOrLocal 3 = Federal 4 = Customer 5 = Other 6 = State 7 = Local 8 = ProSe */
export enum ServingPartyOrgType {
  LawFirm = 1,
  StateOrLocal = 2,
  Federal = 3,
  Customer = 4,
  Other = 5,
  State = 6,
  Local = 7,
  ProSe = 8
}

/** 1 = Safari 2 = Agency */
export enum SftpConnectionType {
  Safari = 1,
  Agency = 2
}

/** 1 = Alabama 2 = Alaska 3 = Arizona 4 = Arkansas 5 = California 6 = Colorado 7 = Connecticut 8 = Delaware 9 = Florida 10 = Georgia 11 = Hawaii 12 = Idaho 13 = Illinois 14 = Indiana 15 = Iowa 16 = Kansas 17 = Kentucky 18 = Louisiana 19 = Maine 20 = Maryland 21 = Massachusetts 22 = Michigan 23 = Minnesota 24 = Mississippi 25 = Missouri 26 = Montana 27 = Nebraska 28 = Nevada 29 = NewHampshire 30 = NewJersey 31 = NewMexico 32 = NewYork 33 = NorthCarolina 34 = NorthDakota 35 = Ohio 36 = Oklahoma 37 = Oregon 38 = Pennsylvania 39 = RhodeIsland 40 = SouthCarolina 41 = SouthDakota 42 = Tennessee 43 = Texas 44 = Utah 45 = Vermont 46 = Virginia 47 = Washington 48 = WestVirginia 49 = Wisconsin 50 = Wyoming 51 = DistrictOfColumbia 52 = Alberta 53 = BritishColumbia 54 = Manitoba 55 = NewBrunswick 56 = Newfoundland 57 = NorthwestTerritories 58 = NovaScotia 59 = Nunavut 60 = Ontario 61 = PrinceEdwardIsland 62 = Quebec 63 = Saskatchewan 64 = Yukon 70 = UsTerritories 71 = Other */
export enum State {
  Alabama = 1,
  Alaska = 2,
  Arizona = 3,
  Arkansas = 4,
  California = 5,
  Colorado = 6,
  Connecticut = 7,
  Delaware = 8,
  Florida = 9,
  Georgia = 10,
  Hawaii = 11,
  Idaho = 12,
  Illinois = 13,
  Indiana = 14,
  Iowa = 15,
  Kansas = 16,
  Kentucky = 17,
  Louisiana = 18,
  Maine = 19,
  Maryland = 20,
  Massachusetts = 21,
  Michigan = 22,
  Minnesota = 23,
  Mississippi = 24,
  Missouri = 25,
  Montana = 26,
  Nebraska = 27,
  Nevada = 28,
  NewHampshire = 29,
  NewJersey = 30,
  NewMexico = 31,
  NewYork = 32,
  NorthCarolina = 33,
  NorthDakota = 34,
  Ohio = 35,
  Oklahoma = 36,
  Oregon = 37,
  Pennsylvania = 38,
  RhodeIsland = 39,
  SouthCarolina = 40,
  SouthDakota = 41,
  Tennessee = 42,
  Texas = 43,
  Utah = 44,
  Vermont = 45,
  Virginia = 46,
  Washington = 47,
  WestVirginia = 48,
  Wisconsin = 49,
  Wyoming = 50,
  DistrictOfColumbia = 51,
  Alberta = 52,
  BritishColumbia = 53,
  Manitoba = 54,
  NewBrunswick = 55,
  Newfoundland = 56,
  NorthwestTerritories = 57,
  NovaScotia = 58,
  Nunavut = 59,
  Ontario = 60,
  PrinceEdwardIsland = 61,
  Quebec = 62,
  Saskatchewan = 63,
  Yukon = 64,
  UsTerritories = 70,
  Other = 71
}

/** 1 = Global 2 = Selected 3 = Participant */
export enum SubtypeAccessLevel {
  Global = 1,
  Selected = 2,
  Participant = 3
}

/** 1 = Team 2 = CompanyEntity */
export enum SupportContactLevel {
  Team = 1,
  CompanyEntity = 2
}

export interface TeamListModel {
  id?: number;
  name?: string | undefined;
  address?: AddressModel | undefined;
  reviewerIsSupportContact?: boolean;
  deliveryPortalContactName?: string | undefined;
  deliveryPortalContactEmail?: string | undefined;
  invoiceContactName?: string | undefined;
  invoiceContactEmail?: string | undefined;
}

export interface TeamListModelPagedResponseModel {
  totalCount?: number;
  items?: TeamListModel[] | undefined;
}

export interface TeamModel {
  id?: number;
  name?: string | undefined;
  address?: AddressModel | undefined;
  reviewerIsSupportContact?: boolean;
  deliveryPortalContactName?: string | undefined;
  deliveryPortalContactEmail?: string | undefined;
  invoiceContactName?: string | undefined;
  invoiceContactEmail?: string | undefined;
}

export interface UpdateCompanyProfileModel {
  name: string;
  fullName?: string | undefined;
  coordinators?: UpdateCoordinatorModel[] | undefined;
  /** 

1 = DefaultOn

2 = DefaultOff

3 = AlwaysOn */
  requireOneTimePinDefault?: RequireOneTimePinDefault;
  /** 

1 = Team

2 = CompanyEntity */
  supportContactLevel?: SupportContactLevel;
}

export interface UpdateCoordinatorModel {
  userId?: number;
  isLead?: boolean;
}

export interface UpdateIntakeFaxSettingsModel {
  faxName?: string | undefined;
  matterSubtypeId?: number;
}

export interface UpdateMyUserProfileModel {
  firstName: string;
  lastName: string;
  email: string;
  jobTitle?: string | undefined;
  timeZone?: string | undefined;
  phoneNumbers?: PhoneNumberModel[] | undefined;
  teamId?: number | undefined;
}

export interface UpdateRegisteredAgentImportModel {
  /** 

1 = InProgress

2 = Completed

3 = Failed */
  status?: RegisteredAgentImportStatus | undefined;
}

export interface UpdateServiceAccountModel {
  name?: string | undefined;
  isActive?: boolean;
}

export interface UpdateTeamAddressModel {
  address: AddressModel;
}

export interface UpdateTeamNameModel {
  name: string;
}

export interface UpdateTeamProfileModel {
  name: string;
  address: AddressModel;
  reviewerIsSupportContact?: boolean;
  deliveryPortalContactName?: string | undefined;
  deliveryPortalContactEmail?: string | undefined;
  invoiceContactName?: string | undefined;
  invoiceContactEmail?: string | undefined;
}

export interface UpdateUserProfileModel {
  firstName: string;
  lastName: string;
  email: string;
  teamId?: number | undefined;
  jobTitle?: string | undefined;
  timeZone?: string | undefined;
  phoneNumbers?: PhoneNumberModel[] | undefined;
  roles?: number[] | undefined;
  securityRoles?: SecurityRole[] | undefined;
  isActive?: boolean;
  /** Indicates the user has access to all matter subtypes */
  hasAccessToAllMatterSubtypes?: boolean;
  /** The matter types that this user can access without being a participant */
  matterTypes?: MatterType[] | undefined;
  /** The matter subtypes that this user can access without being a participant */
  matterSubtypeIds?: number[] | undefined;
}

export interface UpdateX9_129MappingModel {
  /** 

1 = SafariHosted

2 = AgencyHosted */
  requestSource?: RegisteredAgencyRequestSource;
  /** 

1 = X9SafariHosted

2 = X9AgencyHosted

3 = Email */
  responseType?: RegisteredAgencyResponseType;
  agencyFriendlyName?: string | undefined;
  /** The agency's (requester) unformatted FEIN
Needs to match what's sent in the X9 file */
  agencyFein?: string | undefined;
  /** The company's (financial) unformatted FEIN
Needs to match what's sent in the X9 file */
  companyFein?: string | undefined;
  matterSubtypeId?: number;
  entityServedId?: number | undefined;
  /** 

1 = Alabama

2 = Alaska

3 = Arizona

4 = Arkansas

5 = California

6 = Colorado

7 = Connecticut

8 = Delaware

9 = Florida

10 = Georgia

11 = Hawaii

12 = Idaho

13 = Illinois

14 = Indiana

15 = Iowa

16 = Kansas

17 = Kentucky

18 = Louisiana

19 = Maine

20 = Maryland

21 = Massachusetts

22 = Michigan

23 = Minnesota

24 = Mississippi

25 = Missouri

26 = Montana

27 = Nebraska

28 = Nevada

29 = NewHampshire

30 = NewJersey

31 = NewMexico

32 = NewYork

33 = NorthCarolina

34 = NorthDakota

35 = Ohio

36 = Oklahoma

37 = Oregon

38 = Pennsylvania

39 = RhodeIsland

40 = SouthCarolina

41 = SouthDakota

42 = Tennessee

43 = Texas

44 = Utah

45 = Vermont

46 = Virginia

47 = Washington

48 = WestVirginia

49 = Wisconsin

50 = Wyoming

51 = DistrictOfColumbia

52 = Alberta

53 = BritishColumbia

54 = Manitoba

55 = NewBrunswick

56 = Newfoundland

57 = NorthwestTerritories

58 = NovaScotia

59 = Nunavut

60 = Ontario

61 = PrinceEdwardIsland

62 = Quebec

63 = Saskatchewan

64 = Yukon

70 = UsTerritories

71 = Other */
  stateReceived?: State | undefined;
  /** 

1 = LawFirm

2 = StateOrLocal

3 = Federal

4 = Customer

5 = Other

6 = State

7 = Local

8 = ProSe */
  orgType?: ServingPartyOrgType;
  /** The response file name format
5 placeholders are available:
RequesterFein,
FinancialFein,
ResponseDate,
ResponseTime,
SafariId

EXAMPLE: {RequesterFein}.{FinancialFein}.{SafariId}.{ResponseDate:yyyyMMdd}.{ResponseTime:hhmmss}.txt */
  responseFileNameFormat?: string | undefined;
  timeZone?: string | undefined;
  sftpHost?: string | undefined;
  sftpUserName?: string | undefined;
  sftpPassword?: string | undefined;
  sftpIncomingFolderName?: string | undefined;
  sftpOutgoingFolderName?: string | undefined;
  responseEmail?: string | undefined;
}

export interface UserCompanyModel {
  id?: number;
  name?: string | undefined;
  fullName?: string | undefined;
  domainName?: string | undefined;
  lastLoginDate?: string | undefined;
  isActive?: boolean;
}

export interface UserCompanyModelPagedResponseModel {
  totalCount?: number;
  items?: UserCompanyModel[] | undefined;
}

export interface UserListModel {
  id?: number;
  companyId?: number;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  jobTitle?: string | undefined;
  teamId?: number;
  phoneNumbers?: PhoneNumberModel[] | undefined;
  isActive?: boolean;
  roles?: string[] | undefined;
  securityRoles?: SecurityRole[] | undefined;
  /** 

1 = Global

2 = Selected

3 = Participant */
  subtypeAccess?: SubtypeAccessLevel;
  /** Indicates the user has access to all matter subtypes */
  hasAccessToAllMatterSubtypes?: boolean;
  /** The matter types that this user can access without being a participant */
  matterTypes?: MatterType[] | undefined;
  /** The matter subtypes that this user can access without being a participant */
  matterSubtypeIds?: number[] | undefined;
  /** Returns true if this user has a signature image */
  hasSignature?: boolean;
  /** Returns the last login date for this user */
  lastLoginDate?: string | undefined;
  /** Returns true if the user is a coordinator */
  isCoordinator?: boolean;
  /** Returns true if the user is the lead coordinator */
  isLeadCoordinator?: boolean;
}

export interface UserListModelPagedResponseModel {
  totalCount?: number;
  items?: UserListModel[] | undefined;
}

export interface UserModel {
  id?: number;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  isActive?: boolean;
  jobTitle?: string | undefined;
  timeZone?: string | undefined;
  teamId?: number;
  phoneNumbers?: PhoneNumberModel[] | undefined;
  roles?: string[] | undefined;
  securityRoles?: SecurityRole[] | undefined;
  authUserId?: number | undefined;
  /** Returns true if the user is a coordinator */
  isCoordinator?: boolean;
  /** Returns true if the user is the lead coordinator */
  isLeadCoordinator?: boolean;
  /** 

1 = Global

2 = Selected

3 = Participant */
  subtypeAccess?: SubtypeAccessLevel;
  /** Indicates the user has access to all matter subtypes */
  hasAccessToAllMatterSubtypes?: boolean;
  /** The matter types that this user can access without being a participant */
  matterTypes?: MatterType[] | undefined;
  /** The matter subtypes that this user can access without being a participant */
  matterSubtypeIds?: number[] | undefined;
  /** Returns true if this user has a signature image */
  hasSignature?: boolean;
  /** Returns the last login date for this user */
  lastLoginDate?: string | undefined;
}

export interface Void {}

/** 1 = Username 2 = Domain */
export enum WhiteLabelEmailType {
  Username = 1,
  Domain = 2
}

export interface X9_129CompanyMappingModel {
  companyId?: number;
  id?: number;
  /** 

1 = SafariHosted

2 = AgencyHosted */
  requestSource?: RegisteredAgencyRequestSource;
  /** 

1 = X9SafariHosted

2 = X9AgencyHosted

3 = Email */
  responseType?: RegisteredAgencyResponseType;
  agencyFriendlyName?: string | undefined;
  /** The agency's (requester) unformatted FEIN
Needs to match what's sent in the X9 file */
  agencyFein?: string | undefined;
  /** The company's (financial) unformatted FEIN
Needs to match what's sent in the X9 file */
  companyFein?: string | undefined;
  matterSubtypeId?: number;
  entityServedId?: number | undefined;
  /** 

1 = Alabama

2 = Alaska

3 = Arizona

4 = Arkansas

5 = California

6 = Colorado

7 = Connecticut

8 = Delaware

9 = Florida

10 = Georgia

11 = Hawaii

12 = Idaho

13 = Illinois

14 = Indiana

15 = Iowa

16 = Kansas

17 = Kentucky

18 = Louisiana

19 = Maine

20 = Maryland

21 = Massachusetts

22 = Michigan

23 = Minnesota

24 = Mississippi

25 = Missouri

26 = Montana

27 = Nebraska

28 = Nevada

29 = NewHampshire

30 = NewJersey

31 = NewMexico

32 = NewYork

33 = NorthCarolina

34 = NorthDakota

35 = Ohio

36 = Oklahoma

37 = Oregon

38 = Pennsylvania

39 = RhodeIsland

40 = SouthCarolina

41 = SouthDakota

42 = Tennessee

43 = Texas

44 = Utah

45 = Vermont

46 = Virginia

47 = Washington

48 = WestVirginia

49 = Wisconsin

50 = Wyoming

51 = DistrictOfColumbia

52 = Alberta

53 = BritishColumbia

54 = Manitoba

55 = NewBrunswick

56 = Newfoundland

57 = NorthwestTerritories

58 = NovaScotia

59 = Nunavut

60 = Ontario

61 = PrinceEdwardIsland

62 = Quebec

63 = Saskatchewan

64 = Yukon

70 = UsTerritories

71 = Other */
  stateReceived?: State | undefined;
  /** 

1 = LawFirm

2 = StateOrLocal

3 = Federal

4 = Customer

5 = Other

6 = State

7 = Local

8 = ProSe */
  orgType?: ServingPartyOrgType;
  /** The response file name format
5 placeholders are available:
RequesterFein,
FinancialFein,
ResponseDate,
ResponseTime,
SafariId

EXAMPLE: {RequesterFein}.{FinancialFein}.{SafariId}.{ResponseDate:yyyyMMdd}.{ResponseTime:hhmmss}.txt */
  responseFileNameFormat?: string | undefined;
  timeZone?: string | undefined;
  sftpHost?: string | undefined;
  sftpUserName?: string | undefined;
  sftpPassword?: string | undefined;
  sftpIncomingFolderName?: string | undefined;
  sftpOutgoingFolderName?: string | undefined;
  responseEmail?: string | undefined;
}

export interface X9_129CompanyMappingModelPagedResponseModel {
  totalCount?: number;
  items?: X9_129CompanyMappingModel[] | undefined;
}

export interface X9_129MappingModel {
  id?: number;
  /** 

1 = SafariHosted

2 = AgencyHosted */
  requestSource?: RegisteredAgencyRequestSource;
  /** 

1 = X9SafariHosted

2 = X9AgencyHosted

3 = Email */
  responseType?: RegisteredAgencyResponseType;
  agencyFriendlyName?: string | undefined;
  /** The agency's (requester) unformatted FEIN
Needs to match what's sent in the X9 file */
  agencyFein?: string | undefined;
  /** The company's (financial) unformatted FEIN
Needs to match what's sent in the X9 file */
  companyFein?: string | undefined;
  matterSubtypeId?: number;
  entityServedId?: number | undefined;
  /** 

1 = Alabama

2 = Alaska

3 = Arizona

4 = Arkansas

5 = California

6 = Colorado

7 = Connecticut

8 = Delaware

9 = Florida

10 = Georgia

11 = Hawaii

12 = Idaho

13 = Illinois

14 = Indiana

15 = Iowa

16 = Kansas

17 = Kentucky

18 = Louisiana

19 = Maine

20 = Maryland

21 = Massachusetts

22 = Michigan

23 = Minnesota

24 = Mississippi

25 = Missouri

26 = Montana

27 = Nebraska

28 = Nevada

29 = NewHampshire

30 = NewJersey

31 = NewMexico

32 = NewYork

33 = NorthCarolina

34 = NorthDakota

35 = Ohio

36 = Oklahoma

37 = Oregon

38 = Pennsylvania

39 = RhodeIsland

40 = SouthCarolina

41 = SouthDakota

42 = Tennessee

43 = Texas

44 = Utah

45 = Vermont

46 = Virginia

47 = Washington

48 = WestVirginia

49 = Wisconsin

50 = Wyoming

51 = DistrictOfColumbia

52 = Alberta

53 = BritishColumbia

54 = Manitoba

55 = NewBrunswick

56 = Newfoundland

57 = NorthwestTerritories

58 = NovaScotia

59 = Nunavut

60 = Ontario

61 = PrinceEdwardIsland

62 = Quebec

63 = Saskatchewan

64 = Yukon

70 = UsTerritories

71 = Other */
  stateReceived?: State | undefined;
  /** 

1 = LawFirm

2 = StateOrLocal

3 = Federal

4 = Customer

5 = Other

6 = State

7 = Local

8 = ProSe */
  orgType?: ServingPartyOrgType;
  /** The response file name format
5 placeholders are available:
RequesterFein,
FinancialFein,
ResponseDate,
ResponseTime,
SafariId

EXAMPLE: {RequesterFein}.{FinancialFein}.{SafariId}.{ResponseDate:yyyyMMdd}.{ResponseTime:hhmmss}.txt */
  responseFileNameFormat?: string | undefined;
  timeZone?: string | undefined;
  sftpHost?: string | undefined;
  sftpUserName?: string | undefined;
  sftpPassword?: string | undefined;
  sftpIncomingFolderName?: string | undefined;
  sftpOutgoingFolderName?: string | undefined;
  responseEmail?: string | undefined;
}

export interface X9_129MappingModelPagedResponseModel {
  totalCount?: number;
  items?: X9_129MappingModel[] | undefined;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}
